import DominoLetters from './DominoLetters';

export default DominoLetters;
